// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__24CnS","footer":"ModalFilter_footer__2hyX8"};